module.exports = __webpack_public_path__ + "static/media/radis.6b968138.svg";